module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">        \r\n    <div class=\"col-md-12 form-group-flex\">\r\n        <input class=\"timeControls form-radio-group\" type=\"checkbox\" name=\"time24Hour\" id=\"time24Hour\" />\r\n        <label class=\"form-group-label\">24 hour clock</label>\r\n    </div> \r\n</div>\r\n<div class=\"row\">        \r\n    <div class=\"col-md-12 form-group-flex\">\r\n        <input class=\"timeControls form-radio-group\" type=\"checkbox\" name=\"timeShowSeconds\" id=\"timeShowSeconds\" />\r\n        <label class=\"form-group-label\">Show seconds</label>\r\n    </div>\r\n</div>")
  }
  return __output;

}